// extracted by mini-css-extract-plugin
export default {"listItem":"hXM3hykuXsQ4KvAcRJPo"};